import { Route, Navigate } from 'react-router-dom';

import { TechOperatorRoute, PayRoutes } from 'components';
import { ROUTE_PATH as ROUTE_PATH_ALL } from 'constants/routes';
import {
  PayinArchivePage,
  PayoutArchivePage,
  CommonArchivePage,
} from 'features/archive';
import { BlockedCustomersPage } from 'features/blocked-customers';
import { CascadesList, ManageCascade } from 'features/cascades';
import { CommonLimitsPage } from 'features/common-limits';
import {
  CommonConfigsPage,
  PayinConfigsPage,
  PayoutConfigsPage,
} from 'features/configs';
import {
  CounterpartiesPage,
  CounterpartyDetails,
} from 'features/counterparties';
import { CurrencyExchangeRequestsPage } from 'features/currency-exchange-requests';
import { CustomersPage } from 'features/customers';
import { ExecutionMetricsPage } from 'features/execution-metrics';
import { ManageOrderAutomationPage } from 'features/order-automation';
import {
  P2PProvidersPage,
  P2PProviderDetailsPage,
} from 'features/p2p-providers';
import { ManagePayoutOrderAutomationPage } from 'features/payout-order-automation';
import {
  PayoutRequisitesDetailsPage,
  PayoutRequisitesPage,
} from 'features/payout-requisites';
import {
  RequisitesCustomerLimitsPage,
  RequisitesDetailsPage,
  RequisitesGroupDetails,
  RequisitesPage,
} from 'features/requisites';
import {
  RequisitesDistributionCachePage,
  RequisitesDistributionDebugPage,
} from 'features/requisites-distribution';
import { ShopDetailsPage } from 'features/shop';
import { TelegramFlow } from 'features/telegram-flow';
import { TradeMethodDeeplinksPage } from 'features/trade-methods';
import { TrustedCustomersPage } from 'features/trusted-customers';
import {
  TechOperatorMainPage,
  TechOperatorFundsRequestsPage,
  AdminInternalTransfersPage,
  TechOperatorOrdersPage,
  TechOperatorPayinOrdersPage,
  TechOperatorPayoutOrdersPage,
  TechOperatorTradersPage,
  TechOperatorTraderDetails,
  TechOperatorShopsPage,
  TechOperatorPayinCashbackPage,
  TechOperatorPayoutCashbackPage,
  TechOperatorGroupsPage,
  TechOperatorGroupDetailsPage,
  TechOperatorShopGroupsPage,
  TechOperatorShopGroupDetailsPage,
  TechOperatorUsersPage,
  TechOperatorUserDetailsPage,
  TechOperatorSettingsPage,
  TechOperatorCurrenciesPage,
  TechOperatorCurrencyExchangeDetailsPage,
  TechOperatorBanksPage,
  TechOperatorTradeMethodsPage,
  TechOperatorTradeMethodParsingsPage,
  TechOperatorTradeMethodAutomationSourcesPage,
  TechOperatorTradeMethodFilesValidationPage,
  TechOperatorTransactionsPage,
  TechOperatorDepositTransactionsPage,
  TechOperatorWithdrawalTransactionsPage,
  TechOperatorAutomationSourcesPage,
  TechOperatorWebhooksPage,
  TechOperatorSciDomainsPage,
  TechOperatorAssetBalanceHistoryPage,
  TechOperatorAnomaliesPage,
  TechOperatorPayinStatisticsPage,
  TechOperatorPayoutStatisticsPage,
  TechOperatorAuditPage,
} from 'pages';

const ROUTE_PATH = ROUTE_PATH_ALL.TECH_OPERATOR;

export const TechOperatorRoutes = () => (
  <Route path={ROUTE_PATH.MAIN} element={<TechOperatorRoute />}>
    <Route path="" index element={<TechOperatorMainPage />} />
    <Route
      path={ROUTE_PATH.FUNDS_REQUESTS}
      element={<TechOperatorFundsRequestsPage />}
    />
    <Route
      path={ROUTE_PATH.INTERNAL_TRANSFERS}
      element={<AdminInternalTransfersPage />}
    />
    <Route path={ROUTE_PATH.ORDERS} element={<TechOperatorOrdersPage />}>
      <Route
        index
        path={ROUTE_PATH.PAYIN_ORDERS}
        element={<TechOperatorPayinOrdersPage />}
      />
      <Route
        path={ROUTE_PATH.PAYOUT_ORDERS}
        element={<TechOperatorPayoutOrdersPage />}
      />
      <Route path="*" element={<Navigate to={ROUTE_PATH.PAYIN_ORDERS} />} />
    </Route>
    <Route path={ROUTE_PATH.TRADERS} element={<TechOperatorTradersPage />} />
    <Route
      path={ROUTE_PATH.TRADER_DETAILS}
      element={<TechOperatorTraderDetails />}
    />
    <Route path={ROUTE_PATH.SHOPS} element={<TechOperatorShopsPage />} />
    <Route path={ROUTE_PATH.SHOP_DETAILS} element={<ShopDetailsPage />} />
    <Route
      path={`${ROUTE_PATH.CASHBACK}/*`}
      element={
        <PayRoutes
          path={ROUTE_PATH.CASHBACK}
          payinElement={<TechOperatorPayinCashbackPage />}
          payoutElement={<TechOperatorPayoutCashbackPage />}
        />
      }
    ></Route>
    <Route path={ROUTE_PATH.GROUPS} element={<TechOperatorGroupsPage />} />
    <Route
      path={ROUTE_PATH.GROUP_DETAILS}
      element={<TechOperatorGroupDetailsPage />}
    />
    <Route
      path={ROUTE_PATH.SHOP_GROUPS}
      element={<TechOperatorShopGroupsPage />}
    />
    <Route
      path={ROUTE_PATH.SHOP_GROUP_DETAILS}
      element={<TechOperatorShopGroupDetailsPage />}
    />
    <Route path={ROUTE_PATH.USERS} element={<TechOperatorUsersPage />} />
    <Route
      path={ROUTE_PATH.USER_DETAILS}
      element={<TechOperatorUserDetailsPage />}
    />
    <Route path={ROUTE_PATH.SETTINGS} element={<TechOperatorSettingsPage />} />
    <Route
      path={ROUTE_PATH.CURRENCIES}
      element={<TechOperatorCurrenciesPage />}
    />
    <Route
      path={ROUTE_PATH.CURRENCY_EXCHANGE_DETAILS}
      element={<TechOperatorCurrencyExchangeDetailsPage />}
    />
    <Route path={ROUTE_PATH.BANKS} element={<TechOperatorBanksPage />} />
    <Route path={ROUTE_PATH.TRADE_METHODS}>
      <Route
        index
        path={ROUTE_PATH.TRADE_METHODS}
        element={<TechOperatorTradeMethodsPage />}
      />
      <Route
        path={ROUTE_PATH.TRADE_METHOD_PARSINGS}
        element={<TechOperatorTradeMethodParsingsPage />}
      />
      <Route
        path={ROUTE_PATH.TRADE_METHOD_AUTOMATION_SOURCES}
        element={<TechOperatorTradeMethodAutomationSourcesPage />}
      />
      <Route
        path={ROUTE_PATH.TRADE_METHOD_FILES_VALIDATION}
        element={<TechOperatorTradeMethodFilesValidationPage />}
      />
      <Route
        path={ROUTE_PATH.TRADE_METHOD_DEEPLINKS}
        element={<TradeMethodDeeplinksPage />}
      />
    </Route>
    <Route
      path={ROUTE_PATH.TRANSACTIONS}
      element={<Navigate to={ROUTE_PATH.DEPOSIT_TRANSACTIONS} />}
    />
    <Route
      path={ROUTE_PATH.TRANSACTIONS}
      element={<TechOperatorTransactionsPage />}
    >
      <Route
        index
        path={ROUTE_PATH.DEPOSIT_TRANSACTIONS}
        element={<TechOperatorDepositTransactionsPage />}
      />
      <Route
        path={ROUTE_PATH.WITHDRAWAL_TRANSACTIONS}
        element={<TechOperatorWithdrawalTransactionsPage />}
      />
      <Route
        path="*"
        element={<Navigate to={ROUTE_PATH.DEPOSIT_TRANSACTIONS} />}
      />
    </Route>
    <Route
      path={`${ROUTE_PATH.ORDER_AUTOMATION}/*`}
      element={
        <PayRoutes
          path={ROUTE_PATH.ORDER_AUTOMATION}
          payinElement={<ManageOrderAutomationPage />}
          payoutElement={<ManagePayoutOrderAutomationPage />}
        />
      }
    ></Route>
    <Route
      path={ROUTE_PATH.AUTOMATION_SOURCES}
      element={<TechOperatorAutomationSourcesPage />}
    />
    <Route path={ROUTE_PATH.WEBHOOKS} element={<TechOperatorWebhooksPage />} />
    <Route
      path={ROUTE_PATH.SCI_DOMAINS}
      element={<TechOperatorSciDomainsPage />}
    />
    <Route
      path={`${ROUTE_PATH.REQUISITES}/*`}
      element={
        <PayRoutes
          path={ROUTE_PATH.REQUISITES}
          payinElement={<RequisitesPage />}
          payoutElement={<PayoutRequisitesPage />}
          commonElement={<CommonLimitsPage />}
        />
      }
    ></Route>
    <Route
      path={ROUTE_PATH.PAYIN_REQUISITES_DETAILS}
      element={<RequisitesDetailsPage />}
    />
    <Route
      path={ROUTE_PATH.PAYOUT_REQUISITES_DETAILS}
      element={<PayoutRequisitesDetailsPage />}
    />
    <Route
      path={ROUTE_PATH.PAYIN_REQUISITES_GROUP_DETAILS}
      element={<RequisitesGroupDetails />}
    />
    <Route
      path={ROUTE_PATH.PAYIN_REQUISITES_CUSTOMER_LIMITS}
      element={<RequisitesCustomerLimitsPage />}
    />
    <Route
      path={`${ROUTE_PATH.ARCHIVE}/*`}
      element={
        <PayRoutes
          path={ROUTE_PATH.ARCHIVE}
          payinElement={<PayinArchivePage />}
          payoutElement={<PayoutArchivePage />}
          commonElement={<CommonArchivePage />}
        />
      }
    ></Route>
    <Route
      path={ROUTE_PATH.ASSET_BALANCE_HISTORY}
      element={<TechOperatorAssetBalanceHistoryPage />}
    />
    <Route
      path={ROUTE_PATH.ANOMALIES}
      element={<TechOperatorAnomaliesPage />}
    />
    <Route
      path={`${ROUTE_PATH.STATISTICS}/*`}
      element={
        <PayRoutes
          path={ROUTE_PATH.STATISTICS}
          payinElement={<TechOperatorPayinStatisticsPage />}
          payoutElement={<TechOperatorPayoutStatisticsPage />}
        />
      }
    />
    <Route path={ROUTE_PATH.AUDIT} element={<TechOperatorAuditPage />} />
    <Route
      path={ROUTE_PATH.DISTRIBUTION}
      element={<RequisitesDistributionCachePage />}
    />
    <Route
      path={ROUTE_PATH.DISTRIBUTION_DEBUG}
      element={<RequisitesDistributionDebugPage />}
    />
    <Route path={ROUTE_PATH.P2P_PROVIDERS} element={<P2PProvidersPage />} />
    <Route
      path={ROUTE_PATH.P2P_PROVIDERS_DETAILS}
      element={<P2PProviderDetailsPage />}
    />
    <Route
      path={ROUTE_PATH.CURRENCY_EXCHANGE}
      element={<CurrencyExchangeRequestsPage />}
    />
    <Route
      path={ROUTE_PATH.CUSTOMERS}
      element={<Navigate to={ROUTE_PATH.BLOCKED_CUSTOMERS} />}
    />
    <Route path={ROUTE_PATH.CUSTOMERS} element={<CustomersPage />}>
      <Route
        index
        path={ROUTE_PATH.BLOCKED_CUSTOMERS}
        element={<BlockedCustomersPage />}
      />
      <Route
        path={ROUTE_PATH.TRUSTED_CUSTOMERS}
        element={<TrustedCustomersPage />}
      />
      <Route
        path={ROUTE_PATH.COUNTERPARTIES}
        element={<CounterpartiesPage />}
      />
      <Route
        path="*"
        element={<Navigate to={ROUTE_PATH.BLOCKED_CUSTOMERS} />}
      />
    </Route>
    <Route
      path={ROUTE_PATH.COUNTERPARTY_DETAILS}
      element={<CounterpartyDetails />}
    />
    <Route
      path={`${ROUTE_PATH.CONFIGS}/*`}
      element={
        <PayRoutes
          path={ROUTE_PATH.CONFIGS}
          payinElement={<PayinConfigsPage />}
          payoutElement={<PayoutConfigsPage />}
          commonElement={<CommonConfigsPage />}
        />
      }
    ></Route>
    <Route path={ROUTE_PATH.CASCADES} element={<CascadesList />} />
    <Route path={ROUTE_PATH.CASCADE_DETAILS} element={<ManageCascade />} />
    <Route
      path={ROUTE_PATH.EXECUTION_METRICS}
      element={<ExecutionMetricsPage />}
    />
    <Route path={ROUTE_PATH.TELEGRAM_FLOW} element={<TelegramFlow />} />
  </Route>
);
